/**
 * User: Rob Richard
 * Date: 9/19/14
 * Time: 10:33 AM
 */

'use strict';

const $ = require('dibs-jquery-shim');
const get = require('lodash.get');
const moment = require('moment');
const DC = require('bunsen/helpers/dibsCookies');
const { localStorage, sessionStorage } = require('dibs-browser-storage');
const helpers = require('./checkout-helpers.es');
const redirects = require('./checkout-redirects.es');
const { VARS } = require('../models/checkoutConstants.es');

const storage = module.exports = {

    setCookie(prop, val) {
        $.cookie(prop, val, DC.defaultCookieSettings);
    },
    setItem(transactionId, key, value) {
        return localStorage.setItem(`${VARS.STORAGE_PREFIX}${transactionId}${key}`, value);
    },
    getItem(transactionId, key) {
        return localStorage.getItem(`${VARS.STORAGE_PREFIX}${transactionId}${key}`);
    },
    getItemById(transactionId, key) {
        return localStorage.getItem(`${VARS.STORAGE_PREFIX}${transactionId}${key}`);
    },
    deleteItem(transactionId, key) {
        return localStorage.deleteItem(`${VARS.STORAGE_PREFIX}${transactionId}${key}`);
    },
    deleteItemById(transactionId, key) {
        return localStorage.deleteItem(`${VARS.STORAGE_PREFIX}${transactionId}${key}`);
    },
    setSessionItem(key, value) {
        const itemId = redirects.getItemIdFromUrl();
        return sessionStorage.setItem(`${VARS.STORAGE_PREFIX}${itemId}${key}`, value);
    },
    getSessionItem(key) {
        const itemId = redirects.getItemIdFromUrl();
        return sessionStorage.getItem(`${VARS.STORAGE_PREFIX}${itemId}${key}`);
    },
    needsToTrackConfirmation(transactionId) {
        return storage.setItem(transactionId, 'needsToTrackConfirmation', true);
    },
    hasNotTrackedConfirmation(transactionId) {
        return storage.getItemById(transactionId, 'needsToTrackConfirmation');
    },
    trackedConfirmation(transactionId) {
        return storage.deleteItemById(transactionId, 'needsToTrackConfirmation');
    },
    hasTrackedEmail() {
        return storage.getSessionItem('hasTrackedEmail');
    },
    trackedEmail() {
        return storage.setSessionItem('hasTrackedEmail', true);
    },
    setPreAuthOfferModalInfo() {
        return localStorage.setItem('checkoutPreAuthOfferModalInfo', {
            itemId: redirects.getItemIdFromUrl(),
            sellerId: redirects.getParamFromUrl('sellerId'),
            offerAmount: redirects.getParamFromUrl('offerAmount'),
            offerCurrency: redirects.getParamFromUrl('offerCurrency'),
            offerMessage: redirects.getParamFromUrl('message'),
            name: redirects.getParamFromUrl('name'),
            quantity: redirects.getParamFromUrl('quantity'),
            checkoutTime: moment().format()
        });
    },
    getPreAuthOfferModalInfo() {
        return localStorage.getItem('checkoutPreAuthOfferModalInfo');
    },
    clearPreAuthOfferModalInfo() {
        return localStorage.deleteItem('checkoutPreAuthOfferModalInfo');
    },
    updatePreAuthOfferModalInfo(options) {
        const preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
        const preAuthOfferModalPayload = Object.assign({}, preAuthOfferModalInfo, options);
        return localStorage.setItem('checkoutPreAuthOfferModalInfo', preAuthOfferModalPayload);
    },
    getHasSeenPreAuthOfferModal(itemId) {
        return itemId === get(localStorage.getItem('hasSeenPreAuthOfferModal'), 'itemId');
    },
    setHasSeenPreAuthOfferModal(itemId) {
        localStorage.setItem('hasSeenPreAuthOfferModal', {itemId});
    },
    setSurveyInfo() {
        const surveyInfo = storage.getSurveyInfo();
        let orderType;

        if (helpers.isPrivateOffer()) {
            orderType = "Private Offer";
        } else if (helpers.isPreAuthNegotiation()) {
            orderType = "Negotiations 2.0";
        } else if (helpers.isNegotiable()) {
            orderType = "Negotiations 1.5";
        } else {
            orderType = "Full Price";
        }
        return localStorage.setItem('checkoutSurveyInfo', {
            orderType,
            itemId: redirects.getItemIdFromUrl(),
            checkoutTime: moment().format(),
            step: surveyInfo.step
        });
    },
    updateSurveyInfo(options) {
        const surveyInfo = storage.getSurveyInfo();
        const surveyPayload = Object.assign({}, surveyInfo, options);
        return localStorage.setItem('checkoutSurveyInfo', surveyPayload);
    },
    getSurveyInfo() {
        return localStorage.getItem('checkoutSurveyInfo');
    },
    unsetSurveyInfo() {
        return localStorage.deleteItem('checkoutSurveyInfo');
    },
    setHasSeenSurvey() {
        localStorage.setItem('hasSeenCheckoutSurvey', true);
    },
    getHasSeenSurvey() {
        return !!localStorage.getItem('hasSeenCheckoutSurvey');
    },
    incrementAppAdViews() {
        let currentViews = storage.getAppAdViews();
        return localStorage.setItem('checkoutAppAdViews', currentViews++);
    },
    getAppAdViews() {
        const value = localStorage.getItem('checkoutAppAdViews');
        return value ? parseInt(value) : 0;
    },
    itemNotAvailable(item) {
        const title = get(item, 'title');
        storage.setCookie(`${VARS.STORAGE_PREFIX}unavailableItem`, title);
    }
};



// WEBPACK FOOTER //
// ./assets/js/checkout/helpers/checkout-storage.es.js